import { Controller } from "@hotwired/stimulus"

// Auto-fills lower sections (spaces / catering / housing) from the top-level
// `event[guests]` and date inputs. Mounted only on the BO new-event form: on
// edits the controller is not attached, so existing values are never touched.
export default class extends Controller {
  static targets = [
    "guestsSource",
    "fromDateSource",
    "toDateSource",
    "capacity",
    "cateringGuests",
    "cateringDays",
    "housing",
  ]

  syncGuests() {
    const value = this.guestsValue()
    if (value == null) return
    this.applyTo(this.capacityTargets, value)
    this.applyTo(this.cateringGuestsTargets, value)
    this.applyTo(this.housingTargets, value)
  }

  syncDays() {
    const days = this.computeDays()
    if (days == null) return
    this.applyTo(this.cateringDaysTargets, days)
  }

  capacityTargetConnected(el) { this.prefillIfEmpty(el, this.guestsValue()) }
  cateringGuestsTargetConnected(el) { this.prefillIfEmpty(el, this.guestsValue()) }
  cateringDaysTargetConnected(el) { this.prefillIfEmpty(el, this.computeDays()) }
  housingTargetConnected(el) { this.prefillIfEmpty(el, this.guestsValue()) }

  // Private

  applyTo(targets, value) {
    targets.forEach((el) => {
      if (el.value === String(value)) return
      el.value = value
    })
  }

  prefillIfEmpty(el, value) {
    if (value == null) return
    if (el.value !== "" && el.value !== "0") return
    el.value = value
  }

  guestsValue() {
    if (!this.hasGuestsSourceTarget) return null
    const raw = this.guestsSourceTarget.value
    if (raw === "") return null
    const parsed = parseInt(raw, 10)
    return Number.isFinite(parsed) ? parsed : null
  }

  computeDays() {
    if (!this.hasFromDateSourceTarget || !this.hasToDateSourceTarget) return null
    const from = this.parseDate(this.fromDateSourceTarget.value)
    const to = this.parseDate(this.toDateSourceTarget.value)
    if (!from || !to) return null
    const diff = Math.round((to - from) / 86_400_000) + 1
    return Math.max(1, diff)
  }

  parseDate(value) {
    if (!value) return null
    const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
    if (match) {
      const [, day, month, year] = match
      return new Date(`${year}-${month}-${day}T00:00:00`)
    }
    const fallback = new Date(value)
    return Number.isNaN(fallback.getTime()) ? null : fallback
  }
}
